/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PrivilegeDTO,
    PrivilegeDTOFromJSON,
    PrivilegeDTOToJSON,
} from '../models';

export interface SavePrivilegesRequest {
    privilegeDTO: Array<PrivilegeDTO>;
}

/**
 * 
 */
export class PrivilegeControllerApi extends runtime.BaseAPI {

    /**
     */
    async getActionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/privilege/actions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getActions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getActionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPrivilegesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PrivilegeDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/privilege`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrivilegeDTOFromJSON));
    }

    /**
     */
    async getPrivileges(initOverrides?: RequestInit): Promise<Array<PrivilegeDTO>> {
        const response = await this.getPrivilegesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async savePrivilegesRaw(requestParameters: SavePrivilegesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PrivilegeDTO>>> {
        if (requestParameters.privilegeDTO === null || requestParameters.privilegeDTO === undefined) {
            throw new runtime.RequiredError('privilegeDTO','Required parameter requestParameters.privilegeDTO was null or undefined when calling savePrivileges.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/privilege`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.privilegeDTO.map(PrivilegeDTOToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrivilegeDTOFromJSON));
    }

    /**
     */
    async savePrivileges(privilegeDTO: Array<PrivilegeDTO>, initOverrides?: RequestInit): Promise<Array<PrivilegeDTO>> {
        const response = await this.savePrivilegesRaw({ privilegeDTO: privilegeDTO }, initOverrides);
        return await response.value();
    }

}
